import { ColorEnum } from '@enum/style/color.enum';

export const consumerGuideStyle = {
  options: {
    zIndex: 10000,
    primaryColor: ColorEnum.Teal100,
  },
};
